/*
 * @Author: JamesWong
 * @Description: 3.2小票配置
 * @Date: 2019-01-04 14:59:12
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-07 11:41:16
 */
export default {
  confirm: '確定',
  cancel: '取消',
  channel: '渠道',
  added: '新增',
  order: '序號',
  Operation: '操作',
  edit: '編輯',
  templateName: '模板名稱',
  enterTemplateName: '請輸入模板名稱',
  defaults: '默認',
  filters: '渠道性質篩選',
  review: '預覽',
  delete: '刪除',
  createDeposit: '定金單',
  salesCreateReciept: '銷售做單',
  channelNumber: '渠道編號',
  account: '戶口',
  pleaseSelectAgain: '請重新選擇',
  channelRecipetConfiguration: '渠道小票配置',
  recipetTemplate: '小票範本',
  depositTemplate: '定金單範本',
  numberTemplate: '張數範本',
  channelType: '渠道性質',
  recipetStyle: '小票樣式',
  saleVersion: '做單店鋪/顧客聯',
  reprintVersion: '重列印店鋪/顧客聯',
  selectChannelSettings: '選擇管道設置',
  setChannelType: '按渠道性質設置',
  setbyAccount: '按戶口設置',
  channelSelected: '已選管道',
  SaleNum: '銷售做單-店鋪/顧客聯張數',
  ReprintNum: '重列印-店鋪/顧客聯張數',
  selectChannel: '請選擇管道',
  saleRecipetNumberTemplate: '銷售做單張數範本',
  depositRecipetNumberTemplate: '定金單張數模板',
  reprintNumberTemplate: '重列印張數範本',
  businessType: '業務類型',
  number: '張數',
  selectTips: '請先選擇渠道在進行設置小票樣式',
  setTips: '設置成功！',
  styleWarn: '請選擇 "小票樣式" 模板',
  sellWarn: '請選擇 "銷售做單-店鋪/顧客聯張數" 模板',
  sellWarn2: '請選擇 "定金單-店鋪/顧客聯張數" 模板',
  reprintWarn: '請選擇 "重打印-店鋪/顧客聯張數" 模板',
  noset: '暫無配置渠道性質',
  select: '已選擇',
  numTypeSale: '小票-店鋪聯/顧客聯',
  numTypeReprint: '重打印-店鋪聯/顧客聯',
  deleteReceiptModel: '刪除小票模板',
  deleteTips: '確定刪除該小票模板？',
  addtips: '添加成功',
  edittips: '修改成功'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/newSlip.js